import { useEventCallback } from '@cian/react-utils';
import { useMemo } from 'react';

import {
  setActiveInfrastructureItem,
  useMapContext,
  openMap,
  setActiveInfrastructureCategory,
  setCenter,
} from '../../../../packages/MapMobile';
import { IInfrastructureItem } from 'shared/types/infrastructure';
import { trackInfrastructureMapOpenByCategory, trackInfrastructureInModalSelect } from '../tracking';

/* istanbul ignore next */
export const useMapActions = () => {
  const { dispatch } = useMapContext();

  const selectInfrastructureCategoryOnMap = useEventCallback((category: string) => {
    dispatch(setActiveInfrastructureCategory(category));
    trackInfrastructureMapOpenByCategory(category);
  });

  const selectInfrastructureItemOnMap = useEventCallback((infrastructureItem: IInfrastructureItem) => {
    dispatch(setCenter(infrastructureItem.coordinates));
    dispatch(setActiveInfrastructureCategory(infrastructureItem.type));
    dispatch(setActiveInfrastructureItem(infrastructureItem));
    trackInfrastructureInModalSelect(infrastructureItem.type);
  });

  const openMapModal = useEventCallback(() => {
    dispatch(openMap());
  });

  return useMemo(
    () => ({
      selectInfrastructureItemOnMap,
      selectInfrastructureCategoryOnMap,
      openMapModal,
    }),
    [openMapModal, selectInfrastructureCategoryOnMap, selectInfrastructureItemOnMap],
  );
};
